(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.FusionNetix",
                {
                    url: "/FusionNetix",
                    component: "fusionNetix",
                    PageTitle: "FusionNetix",
                    requiredPermissions: "Dol:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);
    
    app.component("fusionNetix",
        {
            templateUrl: "App/Resources/FusionNetix/fusionNetix.html",
            controller: fusionNetixCtrl,
            bindings: {
                states: "<"
            }
        });

    fusionNetixCtrl.$inject = ["amplitudeService"];

    function fusionNetixCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

    }
})(window.app, window.angular); // jshint ignore:line